React = require 'react'
t = require('views/internal/recup-with-helpers')('enterprise_dashboard_single_line_filter')

module.exports = class extends React.Component
  render: t.renderable ->
    { checkedStatus, eventHandlers, item } = @props
    { name } = item

    t.a '.popover-item .u-clearfix',
      href: '#'
      onClick: (e) ->
        e.preventDefault()
        eventHandlers.onClick(item)
    , ->
      t.span '.popover-item-name', ->
        t.format name

      return unless checkedStatus?

      if checkedStatus.isActive(item)
        t.span '.dash-filter-marker .on', ->
          t.icon 'check', { class: 'light' }



// WEBPACK FOOTER //
// ./app/scripts/views/enterprise/dashboard/filters/single-line-filter-component.coffee